import {useCallback} from 'react';

import {AppType} from '@web-catalog/types';

import {useGetVkId} from '@web-catalog/store/auth';

import {logTmrEvent} from '@web-catalog/utils/analytics/logEvent';

export const useChipsAnalytics = () => {
  const getUserId = useGetVkId();

  const logChipsClick = useCallback(
    (
      appType: AppType,
      chips: 'tags' | 'categories' | 'labels' | 'TVMode',
      name: string | null,
      packageName?: string,
    ) => {
      if (name) {
        const logEvent =
          appType === AppType.GAMES
            ? `gamePage.${chips}.click`
            : `appPage.${chips}.click`;

        logTmrEvent({
          logEvent,
          params: {
            app_category_name: name,
            vk_id: getUserId(),
            app_id: packageName,
          },
        });
      }
    },
    [getUserId],
  );
  return {
    logChipsClick,
  };
};
